var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-cy":"partners-content"}},[_c('HeaderPartner'),(_vm.$router.currentRoute.name === 'partners')?_c('ListPartners'):_c('FormNewPartner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }